'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconItalicI, iconItalicITag } from '@ni/nimble-components/dist/esm/icons/italic-i';
import { wrap } from '../../utilities/react-wrapper';

export type { IconItalicI };
export { iconItalicITag };
export const NimbleIconItalicI = wrap(IconItalicI);